import scrollLock from 'scroll-lock';
import View from '../view/view';
import mitt from 'mitt';
import uniqueId from '../../scripts/helpers/uniqueId';
import {useRouter} from "vue-router";
import { nextTick } from 'vue';

class Controller {
	constructor() {
		this.events = mitt();

		this.touch = "ontouchend" in document;

		this.svgIconId = uniqueId('svg-icon-id-');

		this.passiveEventsSupported = (() => {
			// passive event listeners support test from MDN
			let result = false;
			try {
				window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
					get: () => result = true
				}));
			} catch (err) {}
			return result;
		})();

		this.mobileNavData = [];

		document.addEventListener('keydown', (e) => {
			if (e.keyCode === 27) {
				this.closeAll();
			}
		});

		document.querySelector('.js-overlay').addEventListener('click', () => {
			this.closeAll();
		});

		View.initAllGlobal();
		View.initAllLocal(document.body);
	}

	lockPage() {
		scrollLock.disablePageScroll();
	}

	unlockPage() {
		scrollLock.enablePageScroll();
	}

	lockScrolling() {
		const $fillGapElement = document.querySelector('.page-header');
		if ($fillGapElement) {
			scrollLock.addFillGapTarget($fillGapElement);
		}
		scrollLock.disablePageScroll(document.querySelectorAll('.modal__surface'));
	}

	unlockScrolling() {
		scrollLock.enablePageScroll(document.querySelectorAll('.modal__surface'));
	}

	openMobileNav() {
		this.events.emit('mobile-nav-open');
	}

	closeMobileNav() {
		this.events.emit('mobile-nav-close');
	}

	updateMobileNav(data) {
		this.mobileNavData.push(data);
		this.events.emit('mobile-nav-updated', this.mobileNavData);
	}

	openSearchSmall() {
		this.events.emit('search-small-open');
	}

	closeSearchSmall() {
		this.events.emit('search-small-close');
	}

	emitCustomEvent(eventname, response) {
		this.events.emit(eventname, response);
	}

	openModal(options) {
		if (window.modalController) {
			window.modalController.open(options);
		}
	}

	closeModal() {
		if (window.modalController) {
			this.events.emit('modal-close');
			window.modalController.close();
		}
	}

	closeAllModals() {
		if (window.modalController) {
			this.events.emit('modal-close');
			window.modalController.closeAll();
		}
	}

	closeAll() {
		this.closeMobileNav();
		this.closeMobileNav();
		this.closeSearchSmall();
		this.closeAllModals();
	}

	updateModelSource(dataType) {
		this.events.emit('update-model-source', dataType);
	}

	addNotification(data) {
		this.events.emit('add-notification', data);
	}

	hideMobMenu() {
		this.events.emit('mob-menu-hide');
	}

	showMobMenu() {
		this.events.emit('mob-menu-show');
	}

	goToLink(forcedTabId = null) {
		let tabId = forcedTabId;

		if (!tabId) {
			const url = new URL(window.location.href);
			tabId = url.searchParams.get('tab_id');
		}

		if (!tabId) return false;

		const escapedId = CSS.escape(tabId);
		const targetElement = document.querySelector(`[data-hash="#${escapedId}"], #${escapedId}`);

		if (!targetElement) {
			console.warn(`Элемент с id или data-hash равным "${tabId}" не найден.`);
			return false;
		}

		const scrollBefore = window.scrollY;

		setTimeout(() => {
			targetElement.click();

			setTimeout(() => {
				const scrollAfter = window.scrollY;
				if (Math.abs(scrollAfter - scrollBefore) < 10) {
					targetElement.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			}, 500);
		}, 100);

		return true;
	}


}

export default new Controller();